import {
  Spaceable
} from "./chunk.G3SZKTQJ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-column-display/jb-column-display.scss?inline
var jb_column_display_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

div {
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
  width: calc(100% - 2 * var(--row-small-margin, 6.68%));
  height: 8.3333333333vh;
}
@media (min-width: 600px) and (max-width: 959px) {
  div {
    width: calc(100% - 2 * 8.35%);
  }
}
@media (min-width: 1437px) {
  div {
    max-width: var(--row-max-width, 1436px);
  }
  div:not(.filtered-list) {
    width: 100%;
  }
}
@media only screen and (min-width: 960px) and (max-width: 1436px) {
  div {
    margin: 0 6.955%;
    max-width: calc(100% - 6.955% - 6.955%);
  }
}

span {
  box-sizing: border-box;
  flex-basis: 8.3333333333%;
  max-width: 8.3333333333%;
  padding: 0 0;
  width: 8.3333333333%;
  background-color: rgba(0, 128, 0, 0.4);
  border: 1px solid rgb(0, 128, 0);
  border-radius: 5px;
}
@media (min-width: 600px) {
  span {
    box-sizing: border-box;
    flex-basis: 8.3333333333%;
    max-width: 8.3333333333%;
    padding: 0 20px;
    width: 8.3333333333%;
  }
}

div:nth-child(1) span {
  margin-left: 0%;
}

div:nth-child(2) span {
  margin-left: 8.3333333333%;
}

div:nth-child(3) span {
  margin-left: 16.6666666667%;
}

div:nth-child(4) span {
  margin-left: 25%;
}

div:nth-child(5) span {
  margin-left: 33.3333333333%;
}

div:nth-child(6) span {
  margin-left: 41.6666666667%;
}

div:nth-child(7) span {
  margin-left: 50%;
}

div:nth-child(8) span {
  margin-left: 58.3333333333%;
}

div:nth-child(9) span {
  margin-left: 66.6666666667%;
}

div:nth-child(10) span {
  margin-left: 75%;
}

div:nth-child(11) span {
  margin-left: 83.3333333333%;
}

div:nth-child(12) span {
  margin-left: 91.6666666667%;
}`;

// src/components/jb-column-display/jb-column-display.ts
var JbColumnDisplay = class extends Spaceable(h) {
  render() {
    return ke`<div><span></span></div>
      <div><span></span></div>
      <div><span></span></div>
      <div><span></span></div>
      <div><span></span></div>
      <div><span></span></div>
      <div><span></span></div>
      <div><span></span></div>
      <div><span></span></div>
      <div><span></span></div>
      <div><span></span></div>
      <div><span></span></div>`;
  }
};
JbColumnDisplay.styles = r(jb_column_display_default);
__decorateClass([
  n()
], JbColumnDisplay.prototype, "withSpacing", 2);
JbColumnDisplay = __decorateClass([
  customElement("jb-column-display")
], JbColumnDisplay);

export {
  JbColumnDisplay
};
